const data = {
  HivKitCode: "tokens",
  CovidKitCode: "covid19",
  PlazusProdURL: "https://www.community-link.health",
  PlazusDevURL: "https://cl-dshbrd.map-test.plazus.com",
}

export default data;